import { render, staticRenderFns } from "./FaqAndSupportContactsCardLink.vue?vue&type=template&id=41f2f077&scoped=true"
import script from "./FaqAndSupportContactsCardLink.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportContactsCardLink.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportContactsCardLink.vue?vue&type=style&index=0&id=41f2f077&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2f077",
  null
  
)

export default component.exports